const keys = {
    recaptchaId: "6LfqwRoUAAAAAHqTuawEmC_6rZcF13iirayMFhZQ"
}

export default keys;